import './assets/styles/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { vMaska } from 'maska/vue';
import Tooltip from '@/directives/tooltip';
import Vue3TouchEvents from 'vue3-touch-events';
import i18n from '@/utils/i18n';
import App from './App.vue';
import router from './router';
import type { Vue3TouchEventsOptions } from 'vue3-touch-events';

const app = createApp(App);
app.use(createPinia())
  .use(router)
  .use(i18n)
  .directive('tooltip', Tooltip);
app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
  disableClick: false,
});
app.directive('maska', vMaska);
app.mount('#app');
